import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { OperationSearchForm } from '@/models/operationssearch.model'

export default {
  data () {
    return {
      loading: false,
      searchDone: false,
      typesOperations: [' ', 'PAI', 'DAB', 'FAC', 'GUI', 'RET', 'PME'],
      rechercheOperation: new OperationSearchForm(),
      errorMessage: '',
      dateDebut: new Date(),
      dateFin: new Date(),
      currentPage: this.$route.hash ? this.$route.hash.split('#')[1] : 1,
      perPage: 20,
      totalItems: (this.$store.state.entreprise.listOperations && this.$store.state.entreprise.listOperations.nbTotalResults) ? this.$store.state.entreprise.listOperations.nbTotalResults : 0,
      pages: (this.$store.state.entreprise.listOperations && this.$store.state.entreprise.listOperations.nbTotalResults) ? Math.ceil(this.$store.state.entreprise.listOperations.nbTotalResults / 20) : 1

    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  methods: {
    searchOperationsAdmin (beginIndex) {
      this.errorMessage = ''

      this.rechercheOperation.beginIndex = this.perPage * beginIndex
      this.rechercheOperation.endIndex = parseInt(this.rechercheOperation.beginIndex) + this.perPage

      this.loading = true
      this.rechercheOperation.entityId = this.$store.state.user.user.selectedEntreprise.entityId
      this.$store.dispatch('entreprise/searchOperationsAdmin', this.rechercheOperation).then(
        response => {
          this.loading = false
          this.searchDone = true
          this.totalItems = this.$store.state.entreprise.listOperations.nbTotalResults
          this.pages = Math.ceil(this.totalItems / this.perPage)
          if (this.pages < 1) {
            this.pages = 1
          }
        },
        error => {
          this.searchDone = false
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    },
    changeAvailablePage () {
      this.$store.dispatch('entreprise/deleteListOperations')

      this.searchOperationsAdmin(this.currentPage - 1)
    },
    format_date (value) {
      var moment = require('moment')
      if (value) {
        return moment(value).format('DD/MM/YYYY')
      }
    }
  },
  mounted () {
    this.dateDebut.setDate(1)
    this.rechercheOperation.dateDebPeriode = this.dateDebut.toISOString().substr(0, 10)
    this.rechercheOperation.dateFinPeriode = this.dateFin.toISOString().substr(0, 10)

    var self = this
    $(function () {
      $('#datedebut').datepicker({
        onSelect: function (dateText) {
          self.rechercheOperation.dateDebPeriode = dateText
        }
      })
      $('#datefin').datepicker({
        onSelect: function (dateText) {
          self.rechercheOperation.dateFinPeriode = dateText
        }
      })
    })
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Recherche d\'opérations'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
